module.exports = "/_next/static/images/warning-active-8943513f744579420b1366dfca13b771.svg";